window.addEventListener('DOMContentLoaded',()=>{
  // Shared timer sync
  const timerHosts = Array.from(document.querySelectorAll('[data-countdown-rolling]'));
  if (timerHosts.length) {
    const mins = Math.max(1, parseInt(timerHosts[0].dataset.durationMinutes || '40', 10));
    const durationMs = mins * 60 * 1000;
    const key = 'kp_timer_global_end';
    let end = parseInt(localStorage.getItem(key) || '0', 10);
    if (!end || end <= Date.now()) { end = Date.now() + durationMs; localStorage.setItem(key, String(end)); }
    const tick = () => {
      let remaining = end - Date.now();
      if (remaining <= 0) { end = Date.now() + durationMs; localStorage.setItem(key, String(end)); remaining = end - Date.now(); }
      const sec = Math.floor(remaining / 1000);
      const mm = Math.floor(sec / 60);
      const ss = sec % 60;
      timerHosts.forEach(host => {
        host.querySelectorAll('[data-m]').forEach(el => el.textContent = String(mm).padStart(2,'0'));
        host.querySelectorAll('[data-s]').forEach(el => el.textContent = String(ss).padStart(2,'0'));
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  // Viewer counts
  // Try to read saved range for this product from localStorage (set by vendor cards on homepage)
  const productViewerEl = document.querySelector('[data-product-viewers]');
  const _savedRange = (() => {
    try { return JSON.parse(localStorage.getItem('zorgi_viewers_' + location.pathname) || 'null'); } catch(_){ return null; }
  })();
  const _pvMin = _savedRange ? _savedRange.min : 35;
  const _pvMax = _savedRange ? _savedRange.max : 240;
  let productViewers = _savedRange
    ? Math.floor(Math.random() * (_savedRange.max - _savedRange.min + 1)) + _savedRange.min
    : 95;
  const updateProduct = () => {
    if (!productViewerEl) return;
    productViewers += Math.floor(Math.random()*11)-5;
    productViewers = Math.max(_pvMin, Math.min(_pvMax, productViewers));
    productViewerEl.textContent = `${productViewers} People Viewing Right Now`;
  };
  updateProduct();
  setInterval(updateProduct, 3400);

  const topA = document.querySelector('[data-top-viewers]');
  const topB = document.querySelector('[data-top-viewers-2]');
  const updateTop = () => {
    const top = Math.max(productViewers + 12, productViewers + 12 + (Math.floor(Math.random()*21)-10));
    if (topA) topA.textContent = `${top} People Viewing This Right Now`;
    if (topB) topB.textContent = `${Math.max(1, top-6)} People Viewing This Right Now`;
  };
  updateTop();
  setInterval(updateTop, 3800);

  // Card viewers (configurable per card) — also sums to banner live count
  const cardViewerMap = new Map(); // element -> current count

  const syncBannerViewers = () => {
    let total = 0;
    cardViewerMap.forEach(val => { total += val; });
    document.querySelectorAll('.live-viewers').forEach(el => {
      el.textContent = total;
    });
    // persist so product pages can read the real homepage total
    try { localStorage.setItem('zorgi_live_total', total); } catch(_){}
  };

  document.querySelectorAll('.product-card').forEach((card)=>{
    const t = card.querySelector('[data-card-viewers]');
    if(!t) return;
    let min = parseInt(t.dataset.min || '40',10);
    let max = parseInt(t.dataset.max || '60',10);
    if (Number.isNaN(min) || Number.isNaN(max)) { min=40; max=60; }
    if (min>max){ const x=min; min=max; max=x; }

    const productUrl = t.dataset.productUrl;
    if (productUrl) {
      try { localStorage.setItem('zorgi_viewers_' + productUrl, JSON.stringify({min, max})); } catch(_){}
    }

    let cur = Math.floor(Math.random() * (max - min + 1)) + min;
    cardViewerMap.set(t, cur);

    const u = ()=>{
      let next = cur;
      for (let i=0; i<5 && next===cur; i++) {
        next = Math.floor(Math.random() * (max - min + 1)) + min;
      }
      cur = next;
      cardViewerMap.set(t, cur);
      t.textContent = `${cur} Live Viewers`;
      syncBannerViewers();
    };
    u();
    setInterval(u, 1200 + Math.floor(Math.random()*600));
  });

  // Initial sync after all cards set up
  syncBannerViewers();

  // On product pages: fluctuate between 610-700, fast updates like homepage
  const hasBanner = document.querySelectorAll('.live-viewers').length > 0;
  const hasCards = document.querySelectorAll('[data-card-viewers]').length > 0;
  if (hasBanner && !hasCards) {
    let pCount = Math.floor(Math.random() * 91) + 610; // start 610-700
    const updateProductViewers = () => {
      const change = Math.floor(Math.random() * 7) - 3;
      pCount = Math.min(700, Math.max(610, pCount + change));
      document.querySelectorAll('.live-viewers').forEach(el => {
        el.textContent = pCount;
      });
    };
    updateProductViewers();
    setInterval(updateProductViewers, 500);
  }

// Add-to-cart reliable
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-add-to-cart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    let id = btn.dataset.variantId;
    if (!id && btn.dataset.variantSource) {
      const sel = document.getElementById(btn.dataset.variantSource);
      if (sel) id = sel.value;
    }
    if (!id) return;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      window.location.href = '/cart';
    } catch (_) {
      window.location.href = `/cart/${id}:1`;
    }
  }, true);

  // Cart quantity controls by line index
  async function changeLine(line, qty){
    try {
      const res = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line:Number(line),quantity:Number(qty)})
      });
      if (!res.ok) throw new Error('change failed');
    } catch (_) {
      const body = new URLSearchParams();
      body.set(`updates[${Math.max(0, Number(line)-1)}]`, String(Number(qty)));
      await fetch('/cart', {
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
        body:body.toString()
      });
    }
    window.location.reload();
  }
  document.querySelectorAll('[data-inc]').forEach(btn=>btn.addEventListener('click',e=>{
    e.preventDefault();
    const line=btn.dataset.line;
    const input=document.querySelector(`.qty-input[data-line="${line}"]`);
    changeLine(line,Math.max(0,(parseInt(input?.value||'1',10)+1)));
  }));
  document.querySelectorAll('[data-dec]').forEach(btn=>btn.addEventListener('click',e=>{
    e.preventDefault();
    const line=btn.dataset.line;
    const input=document.querySelector(`.qty-input[data-line="${line}"]`);
    changeLine(line,Math.max(0,(parseInt(input?.value||'1',10)-1)));
  }));
  document.querySelectorAll('[data-remove]').forEach(btn=>btn.addEventListener('click',e=>{e.preventDefault();changeLine(btn.dataset.line,0);}));
  document.querySelectorAll('.qty-input[data-line]').forEach(inp=>inp.addEventListener('change',()=>changeLine(inp.dataset.line,Math.max(0,parseInt(inp.value||'1',10)))));

  // Back behavior that works even without browser history
  const isProduct = /^\/products\//.test(location.pathname);
  const isCart = /^\/cart/.test(location.pathname);
  if (!isProduct && !isCart) {
    sessionStorage.setItem('kp_last_store_page', location.pathname + location.search + location.hash);
  }

  const b = document.getElementById('product-back-btn');
  if (b) {
    const saved = sessionStorage.getItem('kp_last_store_page');
    if (saved && saved.startsWith('/')) b.setAttribute('href', saved);
    b.addEventListener('click', (e)=>{
      e.preventDefault();
      const target = b.getAttribute('href') || '/';
      window.location.href = target;
    });
  }

  // Best deal auto first product
  const best = document.getElementById('best-deal-link');
  if (best) {
    const first = document.querySelector('#products-start .product-card .product-image-link, #products-start .product-card .product-title-link, .product-card .product-image-link');
    if (first && first.getAttribute('href')) best.setAttribute('href', first.getAttribute('href'));
  }

  // Review modal + local posted reviews
  const openBtn = document.querySelector('[data-open-review-modal]');
  const closeBtn = document.querySelector('[data-close-review-modal]');
  const modal = document.getElementById('review-modal');
  const form = document.getElementById('review-form');
  const grid = document.getElementById('review-grid');
  const key = 'kp_user_reviews';

  // Interactive star picker
  const starPicker = document.getElementById('star-picker');
  const starInput = document.getElementById('review-stars');
  if (starPicker) {
    const stars = starPicker.querySelectorAll('.star-pick');
    let selectedVal = 0;
    const highlight = (val) => {
      stars.forEach(s => {
        const n = parseInt(s.dataset.val);
        s.classList.toggle('hovered', n <= val);
        s.classList.toggle('active', n <= selectedVal);
      });
    };
    stars.forEach(s => {
      s.addEventListener('mouseenter', () => highlight(parseInt(s.dataset.val)));
      s.addEventListener('mouseleave', () => highlight(selectedVal));
      s.addEventListener('click', () => {
        selectedVal = parseInt(s.dataset.val);
        starInput.value = selectedVal;
        highlight(selectedVal);
      });
    });
  }

  const renderReview = ({name,text,stars,date}) => {
    if (!grid) return;
    const el = document.createElement('article');
    el.className = 'card review user-review';
    el.innerHTML = `<div class="review-top"><div><div class="name"></div><div class="date"></div></div><div class="review-stars"></div></div><p></p>`;
    el.querySelector('.name').textContent = name;
    el.querySelector('.date').textContent = date;
    el.querySelector('.review-stars').textContent = '★★★★★'.slice(0, stars) + '☆☆☆☆☆'.slice(0, 5-stars);
    el.querySelector('p').textContent = text;
    grid.prepend(el);
  };

  try {
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    saved.forEach(renderReview);
  } catch(_) {}

  if (openBtn && modal) openBtn.addEventListener('click', ()=> modal.classList.add('show'));
  if (closeBtn && modal) closeBtn.addEventListener('click', ()=> modal.classList.remove('show'));
  if (modal) modal.addEventListener('click', (e)=>{ if (e.target === modal) modal.classList.remove('show'); });

  if (form) {
    form.addEventListener('submit', (e)=>{
      e.preventDefault();
      const name = document.getElementById('review-name')?.value?.trim();
      const text = document.getElementById('review-text')?.value?.trim();
      const stars = parseInt(document.getElementById('review-stars')?.value || '5',10);
      if (!name || !text) return;
      const review = { name, text, stars: Math.max(1,Math.min(5,stars)), date: new Date().toLocaleDateString() };
      renderReview(review);
      let arr=[];
      try { arr = JSON.parse(localStorage.getItem(key) || '[]'); if (!Array.isArray(arr)) arr=[]; } catch(_) { arr=[]; }
      arr.unshift(review);
      localStorage.setItem(key, JSON.stringify(arr.slice(0,20)));
      form.reset();
      if (modal) modal.classList.remove('show');

      const toast = document.getElementById('review-thanks-toast');
      if (toast) {
        toast.classList.add('show');
        clearTimeout(window.__reviewToastTimer);
        window.__reviewToastTimer = setTimeout(()=>toast.classList.remove('show'), 2400);
      }
    });
  }
});


// v35 reviews: min words + persistent delete for any review card
window.addEventListener('DOMContentLoaded',()=>{
  const grid = document.getElementById('review-grid');
  if (!grid) return;
  const userKey = 'kp_user_reviews';
  const hideKey = 'kp_hidden_reviews';

  const getHidden = () => {
    try { const a=JSON.parse(localStorage.getItem(hideKey)||'[]'); return Array.isArray(a)?a:[]; } catch(_) { return []; }
  };
  const setHidden = (arr) => localStorage.setItem(hideKey, JSON.stringify(arr.slice(0,200)));

  // apply hidden static reviews on load
  const hidden = new Set(getHidden());
  grid.querySelectorAll('.review[data-review-id]').forEach(card=>{
    const id = card.getAttribute('data-review-id');
    if (id && hidden.has(id)) card.remove();
  });

  // harden submit validation (5+ words)
  const form = document.getElementById('review-form');
  if (form) {
    form.addEventListener('submit', (e)=>{
    }, true);
  }

  // delete reviews (static + user-added)
  grid.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-delete-review]');
    if (!btn) return;
    const card = btn.closest('.review');
    if (!card) return;

    const rid = card.getAttribute('data-review-id');
    if (rid) {
      const arr = getHidden();
      if (!arr.includes(rid)) { arr.push(rid); setHidden(arr); }
      card.remove();
      return;
    }

    // user-generated review deletion from localStorage
    if (card.classList.contains('user-review')) {
      const name = card.querySelector('.name')?.textContent?.trim() || '';
      const text = card.querySelector('p')?.textContent?.trim() || '';
      const date = card.querySelector('.date')?.textContent?.trim() || '';
      try {
        const arr = JSON.parse(localStorage.getItem(userKey)||'[]');
        if (Array.isArray(arr)) {
          const next = arr.filter(r => !(r.name===name && r.text===text && r.date===date));
          localStorage.setItem(userKey, JSON.stringify(next));
        }
      } catch(_) {}
      card.remove();
    }
  });

  // ensure user-added cards include delete button
  const mo = new MutationObserver(()=>{
    grid.querySelectorAll('.user-review').forEach(card=>{
      if (!card.querySelector('[data-delete-review]')) {
        const right = card.querySelector('.review-right') || card.querySelector('.review-top');
        if (right) {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'review-delete'; b.setAttribute('data-delete-review',''); b.textContent='✕';
          right.appendChild(b);
        }
      }
    });
  });
  mo.observe(grid, {childList:true, subtree:true});
});


// v36 review identity + image modal (single review per name) + view image
window.addEventListener('DOMContentLoaded',()=>{
  const grid = document.getElementById('review-grid');
  const form = document.getElementById('review-form');
  const modal = document.getElementById('review-modal');
  if (!grid || !form) return;

  const key = 'kp_user_reviews';
  const norm = (v)=> (v||'').trim().toLowerCase().replace(/\s+/g,' ');

  // render helper (with delete + conditional view image)
  const renderCard = (r)=>{
    const el = document.createElement('article');
    el.className = 'card review user-review';
    const stars = '★★★★★'.slice(0, r.stars || 5) + '☆☆☆☆☆'.slice(0, 5 - (r.stars || 5));
    el.innerHTML = `
      <div class="review-top">
        <div>
          <div class="name"></div>
          <div class="date"></div>
        </div>
        <div class="review-right">
          <div class="review-stars"></div>
          <button type="button" class="review-delete" data-delete-review aria-label="Delete review">✕</button>
        </div>
      </div>
      <p></p>
      <div class="review-actions-bottom"></div>
    `;
    el.querySelector('.name').textContent = r.name || 'User';
    el.querySelector('.date').textContent = r.date || '';
    el.querySelector('.review-stars').textContent = stars;
    el.querySelector('p').textContent = r.text || '';
    if (r.image) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'view-image-btn';
      btn.textContent = 'View Image';
      btn.setAttribute('data-view-image', '');
      btn.dataset.image = r.image;
      btn.dataset.name = r.name || '';
      btn.dataset.text = r.text || '';
      el.querySelector('.review-actions-bottom').appendChild(btn);
    }
    return el;
  };

  // clear existing user cards and re-render from storage
  grid.querySelectorAll('.user-review').forEach(n=>n.remove());
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(key)||'[]'); if (!Array.isArray(saved)) saved=[]; } catch(_) { saved=[]; }
  saved.forEach(r=>grid.prepend(renderCard(r)));

  // Submit review - show thank you toast but never display the review on page
  form.addEventListener('submit', (e)=>{
    e.preventDefault();
    e.stopImmediatePropagation();

    const name = (document.getElementById('review-name')?.value || '').trim();
    const text = (document.getElementById('review-text')?.value || '').trim();
    if (!name || !text) return;

    // Reset and close modal
    form.reset();
    document.getElementById('review-stars').value = '';
    const sp = document.getElementById('star-picker');
    if (sp) sp.querySelectorAll('.star-pick').forEach(s => s.classList.remove('active','hovered'));
    if (modal) modal.classList.remove('show');

    // Show thank you toast only - review never appears on page
    const toast = document.getElementById('review-thanks-toast');
    if (toast) {
      toast.classList.add('show');
      clearTimeout(window.__reviewToastTimer);
      window.__reviewToastTimer = setTimeout(()=>toast.classList.remove('show'), 2800);
    }
  }, true);

  // delete and image viewer handlers
  const viewer = document.getElementById('review-image-viewer');
  const preview = document.getElementById('review-image-preview');
  const vName = document.getElementById('review-image-name');
  const vText = document.getElementById('review-image-text');
  const vClose = document.getElementById('review-image-close');

  grid.addEventListener('click', (e)=>{
    const del = e.target.closest('[data-delete-review]');
    if (del) {
      const card = del.closest('.review');
      if (!card) return;
      if (card.classList.contains('user-review')) {
        const n = card.querySelector('.name')?.textContent?.trim() || '';
        saved = saved.filter(r => norm(r.name) !== norm(n));
        localStorage.setItem(key, JSON.stringify(saved));
      }
      card.remove();
      return;
    }

    const view = e.target.closest('[data-view-image]');
    if (view && viewer && preview) {
      preview.src = view.dataset.image || '';
      if (vName) vName.textContent = view.dataset.name || '';
      if (vText) vText.textContent = view.dataset.text || '';
      viewer.classList.add('show');
    }
  });

  if (vClose && viewer) vClose.addEventListener('click', ()=>viewer.classList.remove('show'));
  if (viewer) viewer.addEventListener('click', (e)=>{ if (e.target === viewer) viewer.classList.remove('show'); });
});


// smooth scroll for anchor links
document.addEventListener('click', function(e) {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute('href').slice(1);
  const target = document.getElementById(id);
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
window.addEventListener('DOMContentLoaded',()=>{
  const b=document.getElementById('mobile-menu-toggle');
  const d=document.getElementById('mobile-drawer');
  const o=document.getElementById('drawer-overlay');
  // anchor the drawer directly under the hamburger so it opens in the right place
  // on every screen width (the nav pill is centered, so a fixed left was wrong).
  const positionDrawer=()=>{
    if(!b||!d) return;
    const r=b.getBoundingClientRect();
    const width=d.offsetWidth||220;
    let left=r.left;
    const maxLeft=window.innerWidth-width-12;
    if(left>maxLeft) left=maxLeft;
    if(left<12) left=12;
    d.style.top=Math.round(r.bottom+10)+'px';
    d.style.left=Math.round(left)+'px';
  };
  const close=()=>{
    d.classList.remove('open'); o.classList.remove('show');
    if(b){ b.classList.remove('is-active'); b.setAttribute('aria-expanded','false'); }
  };
  const openDrawer=()=>{
    positionDrawer();
    d.classList.add('open'); o.classList.add('show');
    if(b){ b.classList.add('is-active'); b.setAttribute('aria-expanded','true'); }
  };
  if (b && d) {
    b.addEventListener('click',(e)=>{
      e.stopPropagation();
      d.classList.contains('open') ? close() : openDrawer();
    });
    // keep it aligned if the viewport changes while open
    window.addEventListener('resize',()=>{ if(d.classList.contains('open')) positionDrawer(); });
    window.addEventListener('scroll',()=>{ if(d.classList.contains('open')) positionDrawer(); }, {passive:true});
  }
  // close on click anywhere outside
  document.addEventListener('click',(e)=>{
    if (d && d.classList.contains('open') && !d.contains(e.target) && e.target !== b) {
      close();
    }
  });
  // close on Escape
  document.addEventListener('keydown',(e)=>{ if(e.key==='Escape' && d && d.classList.contains('open')) close(); });
  if (o) o.addEventListener('click', close);
});

// Review pagination - 9 per page on desktop, 6 on mobile
window.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('review-grid');
  const backBtn = document.getElementById('rpag-back');
  const nextBtn = document.getElementById('rpag-next');
  const label = document.getElementById('rpag-label');
  const overflowMsg = document.getElementById('review-overflow-msg');
  if (!grid || !backBtn || !nextBtn || !label) return;

  const getPerPage = () => window.innerWidth <= 640 ? 6 : 9;
  let currentPage = 0;

  const allReviews = () => Array.from(grid.querySelectorAll('.review'));

  const render = () => {
    const PER_PAGE = getPerPage();
    const reviews = allReviews();
    const total = reviews.length;
    const totalPages = Math.max(1, Math.ceil(total / PER_PAGE));
    if (currentPage >= totalPages) currentPage = totalPages - 1;
    const start = currentPage * PER_PAGE;
    const end = start + PER_PAGE;

    reviews.forEach((r, i) => {
      r.style.display = (i >= start && i < end) ? '' : 'none';
    });

    label.textContent = `Page ${currentPage + 1} out of ${totalPages}`;
    backBtn.disabled = currentPage === 0;
    nextBtn.disabled = currentPage >= totalPages - 1;

    if (overflowMsg) {
      overflowMsg.style.display = currentPage >= totalPages - 1 ? 'block' : 'none';
    }
  };

  backBtn.addEventListener('click', () => {
    if (currentPage > 0) { currentPage--; render(); grid.scrollIntoView({behavior:'smooth', block:'nearest'}); }
  });

  nextBtn.addEventListener('click', () => {
    const totalPages = Math.ceil(allReviews().length / getPerPage());
    if (currentPage < totalPages - 1) { currentPage++; render(); grid.scrollIntoView({behavior:'smooth', block:'nearest'}); }
  });

  window.addEventListener('resize', render);
  render();
});

// hide header on scroll down, show on scroll up
(function(){
  const header = document.querySelector('.floating-header');
  if (!header) return;
  let lastY = window.scrollY;
  let ticking = false;

  window.addEventListener('scroll', function(){
    if (!ticking) {
      requestAnimationFrame(function(){
        const currentY = window.scrollY;
        const delta = currentY - lastY;

        if (currentY < 80) {
          // near top - always show
          header.classList.remove('header-hidden');
        } else if (delta > 6) {
          // scrolling down fast enough - hide
          header.classList.add('header-hidden');
        } else if (delta < -4) {
          // scrolling up - show
          header.classList.remove('header-hidden');
        }

        lastY = currentY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

// Spread blue orbs across full content area (stops before footer)
(function(){
  function initOrbs(){
    const layer = document.getElementById('global-orb-layer');
    const wrap = document.getElementById('orb-wrap');
    if (!layer || !wrap) return;

    // Clear any previous orbs
    layer.innerHTML = '';

    const h = wrap.offsetHeight;

    // orbs: [leftPct, topFrac, widthPx, heightPx, opacity]
    const orbs = [
      // very top - header area
      [50,  0.00, 900, 600, 0.20],
      [5,   0.01, 450, 400, 0.13],
      [90,  0.02, 500, 380, 0.12],
      // hero area
      [30,  0.08, 500, 420, 0.10],
      [75,  0.10, 420, 500, 0.10],
      // upper vendor cards
      [12,  0.20, 480, 400, 0.09],
      [60,  0.24, 580, 380, 0.09],
      [88,  0.28, 380, 480, 0.08],
      // mid vendor cards
      [35,  0.38, 520, 420, 0.09],
      [78,  0.43, 400, 520, 0.08],
      [8,   0.47, 460, 380, 0.08],
      // lower vendor cards / reviews
      [55,  0.56, 600, 400, 0.09],
      [20,  0.61, 440, 480, 0.08],
      [82,  0.65, 380, 460, 0.08],
      // faq / bottom sections
      [40,  0.74, 520, 400, 0.09],
      [10,  0.80, 400, 420, 0.08],
      [72,  0.84, 440, 380, 0.08],
      // trust marquee area - just before footer
      [50,  0.92, 700, 380, 0.10],
      [15,  0.95, 380, 340, 0.07],
      [80,  0.95, 350, 360, 0.07],
    ];

    // Use documentFragment for single DOM reflow instead of 20 separate ones
    const frag = document.createDocumentFragment();
    orbs.forEach(([leftPct, topFrac, w, hh, op]) => {
      const el = document.createElement('div');
      el.className = 'orb';
      el.style.cssText = [
        'width:' + w + 'px',
        'height:' + hh + 'px',
        'left:calc(' + leftPct + '% - ' + (w/2) + 'px)',
        'top:' + Math.round(h * topFrac) + 'px',
        'background:radial-gradient(ellipse, rgba(0,51,255,' + op + ') 0%, transparent 70%)',
      ].join(';');
      frag.appendChild(el);
    });
    layer.appendChild(frag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrbs);
  } else {
    initOrbs();
  }
  // Re-run after all images/fonts load so heights are accurate
  window.addEventListener('load', function(){
    // small delay to let any lazy content settle
    setTimeout(initOrbs, 200);
  });
})();

// First vendor card shake every 5 seconds
(function(){
  function startCardShake(){
    const firstCard = document.querySelector('.product-card');
    if (!firstCard) return;
    const shake = () => {
      firstCard.classList.add('is-shaking');
      setTimeout(() => firstCard.classList.remove('is-shaking'), 500);
    };
    shake();
    setInterval(shake, 5000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCardShake);
  } else {
    startCardShake();
  }
})();
